import { getLocalePath } from '@src/components/seo/seo-page-router.helper'
import { NEXT_PUBLIC_SITE_URL } from '@src/config/env'
import { getProductLink } from '@src/quince-components/src/molecules/productCard/productCard.helpers'
import Product from '@src/quince-site-common/src/domains/Product'
import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant/BaseProductVariant'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

import { DYNAMIC_APP_LINK } from '../../../utils/constants'

export function buildPageUrl({
  locale,
  product,
  selectedOptions,
}: {
  slug?: string
  locale: string
  product?: Product
  selectedOptions?: ProductVariantOption[]
}) {
  if (!product && isBrowser()) {
    return window.location.href
  }

  const productLink = product ? getProductLink(product, selectedOptions ?? []) : ''
  const productLinkWithoutLeadingSlash = productLink.startsWith('/') ? productLink.substring(1) : productLink
  const productLinkWithLocale = getLocalePath(locale, productLinkWithoutLeadingSlash)
  const url = `${NEXT_PUBLIC_SITE_URL}/${productLinkWithLocale}`
  return url
}

export function buildAppDeepLinkUrl(pageUrl: string): string {
  const encodedUrl = encodeURIComponent(pageUrl)
  const url = new URL(DYNAMIC_APP_LINK)

  url.searchParams.set('pid', 'website')
  url.searchParams.set('c', 'app_exclusive')
  url.searchParams.set('deep_link_value', encodedUrl)

  return url.toString()
}
